// NGRX
import {EntityState, EntityAdapter, createEntityAdapter} from '@ngrx/entity';
// Actions
import {OutdoorSpaceActions, OutdoorSpaceActionTypes} from '../_actions/outdoor-space.actions';
// Models
import {OutdoorSpaceModel} from '../_models/outdoor-space.model';
import {QueryParamsModel} from '../../_base/crud';

export interface OutdoorSpacesState extends EntityState<OutdoorSpaceModel> {
    isAllOutdoorSpacesLoaded: boolean;
    queryRowsCount: number;
    queryResult: OutdoorSpaceModel[];
    lastCreatedOutdoorSpaceId: number;
    listLoading: boolean;
    actionLoading: boolean;
    totalCount: number;
    totalTrashed: number;
    totalAdminTrashed: number;

    lastQuery: QueryParamsModel;
    showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<OutdoorSpaceModel> = createEntityAdapter<OutdoorSpaceModel>();

export const initialOutdoorSpaceState: OutdoorSpacesState = adapter.getInitialState({
    isAllOutdoorSpacesLoaded: false,
    queryRowsCount: 0,
    queryResult: [],
    lastCreatedOutdoorSpaceId: undefined,
    listLoading: false,
    actionLoading: false,
    totalCount: 0,
    totalTrashed: 0,
    totalAdminTrashed: 0,
    lastQuery: new QueryParamsModel({}),
    showInitWaitingMessage: true
});

export function outdoorSpaceReducer(state = initialOutdoorSpaceState, action: OutdoorSpaceActions): OutdoorSpacesState {
    switch (action.type) {
        case OutdoorSpaceActionTypes.OutdoorSpacesPageToggleLoading:
            return {
                ...state, listLoading: action.payload.isLoading, lastCreatedOutdoorSpaceId: undefined
            };
        case OutdoorSpaceActionTypes.OutdoorSpaceActionToggleLoading:
            return {
                ...state, actionLoading: action.payload.isLoading
            };
        case OutdoorSpaceActionTypes.OutdoorSpaceOnServerCreated:
            return {
                ...state
            };
        case OutdoorSpaceActionTypes.OutdoorSpaceCreated:
            return adapter.addOne(action.payload.item, {
                ...state, lastCreatedOutdoorSpaceId: action.payload.item.id
            });
        case OutdoorSpaceActionTypes.OutdoorSpaceUpdated:
            return adapter.updateOne(action.payload.partialItem, state);

        case OutdoorSpaceActionTypes.AllOutdoorSpacesLoaded:
            return adapter.addAll(action.payload.items, {
                ...state, isAllOutdoorSpacesLoaded: true
            });
        case OutdoorSpaceActionTypes.OutdoorSpacesPageCancelled:
            return {
                ...state, listLoading: false, queryRowsCount: 0, queryResult: [], lastQuery: new QueryParamsModel({})
            };
        case OutdoorSpaceActionTypes.OutdoorSpacesPageLoaded:
            return adapter.addMany(action.payload.items, {
                ...initialOutdoorSpaceState,
                totalCount: action.payload.totalCount,
                totalTrashed: action.payload.totalTrashed,
                totalAdminTrashed: action.payload.totalAdminTrashed,
                listLoading: false,
                lastQuery: action.payload.page,
                showInitWaitingMessage: false
            });

        case OutdoorSpaceActionTypes.OutdoorSpaceDeleted:
            return adapter.removeOne(action.payload.id, {
                ...state, totalTrashed: state.totalTrashed + 1
            });

        case OutdoorSpaceActionTypes.OutdoorSpaceRestored:
            return adapter.addOne(action.payload.item, {
                ...state, totalTrashed: state.totalTrashed - 1
            });

        case OutdoorSpaceActionTypes.OutdoorSpaceDeletedFromTrash:
            return {
                ...state, totalTrashed: state.totalTrashed - 1, totalAdminTrashed: state.totalAdminTrashed + 1
            };

        // Admin Trash Action
        case OutdoorSpaceActionTypes.OutdoorSpaceAdminRestored:
            return adapter.addOne(action.payload.item, {
                ...state, totalAdminTrashed: state.totalAdminTrashed - 1
            });

        case OutdoorSpaceActionTypes.OutdoorSpaceDeletedFromAdminTrash:
            return {
                ...state, totalAdminTrashed: state.totalAdminTrashed - 1
            };
        case OutdoorSpaceActionTypes.OutdoorSpaceTrashFlushed:
            return {
                ...state, totalTrashed: 0, totalAdminTrashed: state.totalAdminTrashed + state.totalTrashed
            };
        default:
            return state;
    }
}

export const {
    selectAll,
    selectEntities,
    selectIds,
    selectTotal
} = adapter.getSelectors();
